import { Routes, Route, Navigate } from "react-router-dom";
import { Login } from "../modules";
import JoinUs from "../modules/join-us/join-us";
import AdminDashboard from "../modules/admin-dashboard/admin-dashboard";
import ForgetPassword from "../modules/forget-password/forget-password";
import GenerateToken from "../modules/admin-dashboard/nested-routes/generate-token";
import MyProfile from "../modules/admin-dashboard/nested-routes/my-profile";
import IndexPage from "../modules/admin-dashboard/nested-routes/IndexPage";
import TokensDetails from "../modules/admin-dashboard/nested-routes/tokens-detail";
import { useSelector } from "react-redux";
import { useState } from "react";
import ResetPassword from "../modules/reset-password/reset-password";
import VerifyUsers from "../modules/admin-dashboard/nested-routes/verify-user";

const AppRouters = () => {
  const auth = useSelector((state) => state?.appStore?.auth);
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/forget-password" element={<ForgetPassword />} />
      <Route path="/join-us" element={<JoinUs/>} />
      <Route path="/reset-password" element={<ResetPassword />} />
      {
        auth && (
          <Route path="/dashboard" element={<AdminDashboard />}>
            {/* Nested Routes */}
            {auth.user[0].role_name == 'admin' && (
              <>
                <Route index path="generate-tokens" element={<GenerateToken />} />
                <Route path="view-profile" element={<MyProfile />} />
                <Route path="tokens-detail" element={<TokensDetails />} />
              </>
            )}
            {auth.user[0].role_name == 'super-admin' && (
              <>
                <Route path="verify-users" element={<VerifyUsers />} />
              </>
            )}
          </Route>
        )
      }

      {/* NO MATCHING ROUTE FOUND */}
      <Route path="*" element={<Navigate to="/" />} />


    </Routes>
  );
};

export default AppRouters;
